import levels from "./Levels";

class ConfigProvider {
  defaultConfig = {
    level: "INFO",
    console: false,
    localStorage: true,
    logPanel: true,
    bufferSize: 100,
    logSize: 10000,
    logCount: 5,
  };

  config = {
    level: "",
    console: true,
    localStorage: true,
    logPanel: true,
    bufferSize: 0,
    logSize: 0,
    logCount: 0,
  };

  constructor() {
    let config = this.GetConfigFromLocalStorage();
    if (!!config) {
      this.SetConfig(JSON.parse(config));
    } else {
      this.SetConfig(this.defaultConfig);
      this.SetDefaultConfigInLocalStorage();
    }
  }

  GetConfigFromLocalStorage() {
    return localStorage.getItem("Log");
  }

  SetConfig(config) {
    this.config = config;
  }

  SetDefaultConfigInLocalStorage() {
    this.SaveConfigInLocalStorage(JSON.stringify(this.defaultConfig));
  }

  SaveConfigInLocalStorage(config) {
    localStorage.setItem("Log", config);
  }

  SetLevel(level) {
    this.config.level = level;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  GetLevel() {
    return this.config.level;
  }

  GetLevelValue() {
    return levels[this.config.level];
  }

  SetConsole(bool) {
    this.config.console = bool;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  GetConsole() {
    return this.config.console;
  }

  SetLocalStorageParam(bool) {
    this.config.localStorage = bool;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  SetLogPanelParam(bool) {
    this.config.logPanel = bool;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  GetLocalStorageParam() {
    return this.config.localStorage;
  }

  SetBufferSize(bufferSize) {
    this.config.bufferSize = bufferSize;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  GetBufferSize() {
    return this.config.bufferSize;
  }

  SetLogCount(logCount) {
    this.config.logCount = logCount;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  GetLogCount() {
    return this.config.logCount;
  }

  SetLogSize(logSize) {
    this.config.logSize = logSize;
    this.SaveConfigInLocalStorage(JSON.stringify(this.config));
  }

  GetLogSize() {
    return this.config.logSize;
  }
}

export default ConfigProvider;
